export const list = {
  table: {
    id: '順番',
    companyId: '担当者 ID',
    companyName: '担当者名',
    createdAt: '作成日',
  },
  pageHeader: {
    title: '操作員',
    titleOperatorsList: '個人データの登録/編集',
    new: '新規',
  },
}
